const FindStateData=async (apiHandler,endpoint,authToken, dispatch, savestateData ,setStateList )=>{
    const result = await apiHandler({
        url: endpoint.MASTER_STATE_FINDALL,
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        console.log("Error in MasterState Api");
      } else {
        result?.data?.sort(function(a, b) { 
            return  a.name.localeCompare(b.name); 
          });
        setStateList(result?.data)
      dispatch(
          savestateData(result?.data)
        );
      }
}

export default FindStateData;
